import { render, staticRenderFns } from "./uklon_photo.vue?vue&type=template&id=1bbed96e&scoped=true&"
import script from "./uklon_photo.vue?vue&type=script&lang=js&"
export * from "./uklon_photo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbed96e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bbed96e')) {
      api.createRecord('1bbed96e', component.options)
    } else {
      api.reload('1bbed96e', component.options)
    }
    module.hot.accept("./uklon_photo.vue?vue&type=template&id=1bbed96e&scoped=true&", function () {
      api.rerender('1bbed96e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/uklon/location/tabs/image_tabs/uklon_photo.vue"
export default component.exports